import React, { useEffect, useState } from 'react'
import RouteComponent from '../../RouteComponent/RouteComponent'
import Button from '../../../ui/Button/Button'
import { db } from '../../../config/firebase'
import Spinner from '../../../ui/Spinner/Spinner'
import InfoLine from '../../../ui/InfoLine/InfoLine'
import { formatDateAsDayMontYearHHMM } from '../../../utils/date/dateFormat'
import './SmiList.sass'
import { isEmpty } from 'lodash'
import Icon from '../../../ui/Icon/Icon'
import { withRouter } from 'react-router'
import DeletePopUp from '../../../ui/PopUp/DeletePopUp/DeletePopUp'
import onFeedDelete from '../SmiManager/functions/deleteFeed'
import parse from 'html-react-parser'

function SmiList({ ...router }) {
  const [feedCatalog, setFeedCatalog] = useState(null)
  const [deleteFeed, setDeleteFeed] = useState(null)

  useEffect(() => {
    db.collection('smi').onSnapshot((docs) => {
      const data = []
      docs.forEach((d) => data.push({ naukId: d.id, ...d.data() }))
      setFeedCatalog(data)
    })
  }, [])

  return (
    <RouteComponent
      title="ЗМІ"
      controlls={
        <>
          <Button
            title="Додати запис"
            icon="plus"
            fill="accent"
            theme="solid"
            type="navlink"
            path="/pages/smi/add"
            size={28}
          />
        </>
      }
    >
      {deleteFeed && (
        <DeletePopUp
          title="Видалення запису"
          warningMessage={`Ви впевнені, що хочете видалити запис від "${formatDateAsDayMontYearHHMM(
            deleteFeed.created
          )}"?`}
          closePopUp={() => setDeleteFeed(null)}
          submitDelete={() => onFeedDelete({ naukId: deleteFeed.naukId })}
        />
      )}
      <div className="ToursCatalog">
        {feedCatalog ? (
          isEmpty(feedCatalog) ? (
            <p className="EmptyText">Немає записів</p>
          ) : (
            feedCatalog.map((t, i) => (
              <TourTile
                key={`nauk-${i}`}
                {...t}
                onEdit={() =>
                  router.history.push(`/pages/smi/edit/${t.naukId}`)
                }
                onDelete={() =>
                  setDeleteFeed({
                    created: t.created,
                    naukId: t.naukId,
                  })
                }
              />
            ))
          )
        ) : (
          <Spinner type="module" />
        )}
      </div>
    </RouteComponent>
  )
}

function TourTile({ video, text, onEdit, onDelete, created }) {
  return (
    <div className="FeedTile" onDoubleClick={onEdit}>
      <div className="Content">
        <InfoLine title="Дата" content={formatDateAsDayMontYearHHMM(created)} />
        <InfoLine title="Текст" content={parse(text)} />
      </div>
      <div className="Options">
        <div className="OptionButton Accent" onClick={onEdit}>
          <Icon name="pencil-alt" />
        </div>
        <div className="OptionButton Red" onClick={onDelete}>
          <Icon name="trash-alt" />
        </div>
      </div>
    </div>
  )
}

export default withRouter(SmiList)
